import { firestore } from 'firebase/app'
import { FirestoreQuery } from '../Firestore/FirestoreQuery'
import { ProductPricing } from './ProductPricing'
import { ProductPricingMapper } from './ProductPricingMapper'

export class ProductPricingCollection {
  protected collection: string = 'productPricing'

  constructor(protected db: firestore.Firestore, protected batch?: firestore.WriteBatch) {}

  watchProductPricing(id: string): { data: ProductPricing | null } {
    const query = this.initQuery()
    return query.watch(id)
  }

  getProductPricing(id: string): Promise<ProductPricing | null> {
    const query = this.initQuery()
    return query.find(id)
  }

  async getProductPricingByDescription(description: string): Promise<ProductPricing | null> {
    const query = this.initQuery()
    query.setQuery(this.getProductPricingsByDescriptionQuery(query, description).limit(1))
    const productPricings = await query.list()
    return productPricings.length ? productPricings[0] : null
  }

  save(productPricing: ProductPricing): Promise<ProductPricing> {
    const query = this.initQuery()
    return query.save(productPricing)
  }

  delete(productPricing: ProductPricing) {
    const query = this.initQuery();
    return query.delete(productPricing)
  }

  protected initQuery(): FirestoreQuery<ProductPricing> {
    const query = new FirestoreQuery<ProductPricing>(this.db, new ProductPricingMapper())
    query.collection(this.collection)

    return query
  }

  protected getProductPricingsByDescriptionQuery(query: FirestoreQuery<ProductPricing>, description: string) {
    return this.getProductPricingsByFieldValue(query, 'description', description)
  }

  protected getProductPricingsByFieldValue(query: FirestoreQuery<ProductPricing>, field: string, value: any) {
    return query.collection(this.collection).where(field, '==', value)
  }
}
